import React from "react";
import { Tag, Space, Button, Popconfirm } from "antd";
import { EditOutlined, KeyOutlined, DeleteOutlined } from "@ant-design/icons";
import DataTable from "../../../components/DataTable";

export default function SkeyepredictUsersTable({
  data,
  loading,
  page,
  pageSize,
  onPageChange,
  onEditUser,
  onEditRole,
  onManageAccess,
  onDeleteUser,
  isRoleUser,
}) {
  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: "10%",
      sorter: (a, b) =>
        (a.id || "").toString().localeCompare((b.id || "").toString()),
    },
    {
      title: "Username",
      dataIndex: "username",
      key: "username",
      width: "20%",
      sorter: (a, b) => (a.username || "").localeCompare(b.username || ""),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: "25%",
      sorter: (a, b) => (a.email || "").localeCompare(b.email || ""),
    },
    {
      title: "Roles",
      dataIndex: "roles",
      key: "roles",
      width: "20%",
      render: (roles, record) => (
        <Space size="small" align="center">
          <div>
            {(roles || []).map((role, idx) => (
              <Tag color="geekblue" key={idx}>
                {role.name === "ROLE_USER"
                  ? "User"
                  : role.name === "ROLE_ADMIN"
                    ? "Admin"
                    : role.name}
              </Tag>
            ))}
          </div>
          {!isRoleUser && (
            <Button
              type="text"
              icon={<EditOutlined />}
              onClick={() => onEditRole(record)}
              style={{ color: "#0D2E4D", padding: 0 }}
              title="Edit Role"
            />
          )}
        </Space>
      ),
    },
    {
      title: "Active",
      dataIndex: "active",
      key: "active",
      width: "10%",
      render: (active) => (
        <Tag color={active ? "success" : "error"}>{active ? "Yes" : "No"}</Tag>
      ),
      sorter: (a, b) => (a.active === b.active ? 0 : a.active ? 1 : -1),
    },
  ];

  if (!isRoleUser) {
    columns.push({
      title: "Actions",
      key: "actions",
      width: "15%",
      render: (_, record) => (
        <Space size="small">
          <Button
            type="text"
            icon={<EditOutlined />}
            onClick={() => onEditUser(record)}
            style={{ color: "#e29b45" }}
            title="Edit User"
          />
          <Button
            type="text"
            icon={<KeyOutlined />}
            onClick={() => onManageAccess(record)}
            style={{ color: "#D97A07" }}
            title="Manage Access"
          />
          <Popconfirm
            title="Delete User"
            description={`Are you sure you want to delete ${record.username}?`}
            onConfirm={() => onDeleteUser(record.id)}
            okText="Yes"
            cancelText="No"
            okButtonProps={{ danger: true }}
          >
            <Button
              type="text"
              danger
              icon={<DeleteOutlined />}
              title="Delete User"
            />
          </Popconfirm>
        </Space>
      ),
    });
  }

  return (
    <DataTable
      rowKey="id"
      columns={columns}
      data={data}
      loading={loading}
      page={page}
      pageSize={pageSize}
      onPageChange={onPageChange}
    />
  );
}
